module.exports = __webpack_public_path__ + "img/OHS1-big.bcaf5cf1.png";